import { render } from "./Boosts.vue?vue&type=template&id=60ca19de"
import script from "./Boosts.vue?vue&type=script&lang=js"
export * from "./Boosts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/shop/Boosts.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "60ca19de"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('60ca19de', __exports__)) {
    api.reload('60ca19de', __exports__)
  }
  
  module.hot.accept("./Boosts.vue?vue&type=template&id=60ca19de", () => {
    api.rerender('60ca19de', render)
  })

}


export default __exports__